import { designSystemColors, otherColors } from '../styles/colors';

import type { DesignSystemColorTypes, OtherColorTypes } from '../styles/colors';

export const expandColors = (
  data: { length: number; },
  colors: { color: string; }[] | undefined = [],
)  => 
  Array.from({ length: data.length }, (_, i) => {
    const name = (colors && colors[i]?.color) || 'sage';
    const rgb = designSystemColors[name as DesignSystemColorTypes] || otherColors[name as OtherColorTypes];
    return { name, rgb };
  });


export const c = {
  lavender: [
    designSystemColors.lavender,
    designSystemColors.lavenderTint,
    designSystemColors.lavenderShade,
    designSystemColors.lavenderMidTint,
    designSystemColors.lavenderLight,
  ],
  poppy: [
    designSystemColors.poppy,
    designSystemColors.poppyTint,
    designSystemColors.poppyShade,
    designSystemColors.poppyMidTint,
    designSystemColors.poppyLight,
  ],
  sage: [
    designSystemColors.sage,
    designSystemColors.sageTint,
    designSystemColors.sageShade,
    designSystemColors.sageMidTint,
    designSystemColors.sageLight,
  ],
};

export const lineChartColors = { 
  lightSand: [
    { color: 'poppyShade' }, 
    { color: 'lavenderShade' }, 
    { color: 'sageShade' }, 
    { color: 'lakeShade' }, 
    { color: 'gray70' }], 
  charcoal: [
    { color: 'poppy' }, 
    { color: 'lavenderTint' }, 
    { color: 'sageTint' },
    { color: 'lakeTint' }, 
    { color: 'gray70' },
  ], 
};

export const barChartColors = [
  designSystemColors.poppy,
  designSystemColors.lavender,
  designSystemColors.sageTint,
];

export const formatValue = (numberFormat: string, value: number | string, locale = 'en-us') => {
  if (isNaN(+value)) return String(value);
  if (numberFormat === 'percentage') {
    return new Intl.NumberFormat(locale, { style: 'percent', maximumFractionDigits: 4 }).format(+value / 100);
  } else if (numberFormat === 'euros') {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'EUR' }).format(+value);
  } else if (numberFormat === 'british_pounds') {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'GBP' }).format(+value);
  } else if (numberFormat === 'usd') {
    return new Intl.NumberFormat(locale, { style: 'currency', currency: 'USD' }).format(+value);
  }
  return new Intl.NumberFormat(locale).format(+value);
};
